const REMOVING_CHARS = ['+', '-', '(', ')', ' '];

export function removePhoneFormat(phone_number: string): string {
    return phone_number
        .split('')
        .filter(char => !REMOVING_CHARS.includes(char))
        .join('');
}
